import styled from 'styled-components';
import TransactionTombstone from './Transactions/TransactionTombstone';

const TransactionCardDivStyled = styled.div`
  .transaction-item {
    flex: 1 1 100%;
  }

  .transaction-item-container {
    background-color: white;
    box-shadow: var(--card-shadow);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100%;
    justify-content: center;
    position: relative;
    padding: 2rem 2rem;
    width: 100%;
  }

  .transaction-section-container {
    gap: 3rem;
    margin-top: 10rem;
    padding-bottom: 10rem;
    justify-content: center;
    align-items: center;

    &.preload * {
      animation: none !important;
      transition: none !important;
    }
  }

  .transaction-quote {
    font-size: 1.2rem;
    line-height: 1.4rem;
    margin: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    word-break: break-word;
  }
`;

const TransactionCard = (props) => {
  const { transaction } = props;

  return (
    <TransactionCardDivStyled className="transaction-item">
      {transaction.transactionTombstoneImage1 && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage1}
          alt={transaction.transactionTombstoneAltText1}
        />
      )}
      <p className="transaction-quote">{transaction.transactionTombstoneDescription}</p>
      {transaction.transactionTombstoneImage2 && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage2}
          alt={transaction.transactionTombstoneAltText2}
        />
      )}
      {transaction.transactionTombstoneImage3 && (
        <TransactionTombstone
          src={transaction.transactionTombstoneImage3}
          alt={transaction.transactionTombstoneAltText3}
        />
      )}
    </TransactionCardDivStyled>
  );
};

export default TransactionCard;
